import Foundation from "@microsoft/fast-components-foundation-react";
import { DesignSystemDefaults, neutralLayerL1, } from "@microsoft/fast-components-styles-msft";
import { DesignSystemConsumer, DesignSystemProvider, } from "@microsoft/fast-jss-manager-react";
import { get, has, memoize } from "lodash-es";
import React from "react";
export default class Background extends Foundation {
    constructor() {
        super(...arguments);
        this.handledProps = {
            tag: void 0,
            value: void 0,
            drawBackground: void 0,
            designSystemMergingFunction: void 0,
        };
        this.getDesignSystemOverrides = memoize((color) => {
            return { backgroundColor: color };
        });
        this.withContext = (designSystem) => {
            const background = this.props
                .value;
            const color = typeof background === "string"
                ? background
                : typeof background === "function"
                    ? background(designSystem)
                    : has(designSystem.neutralPalette, background)
                        ? get(designSystem.neutralPalette, background)
                        : DesignSystemDefaults.neutralPalette[background] ||
                            Background.defaultProps.value(DesignSystemDefaults);
            const style = Object.assign({}, this.props.style, this.props.drawBackground
                ? {
                    backgroundColor: color,
                }
                : void 0);
            return (React.createElement(DesignSystemProvider, { designSystem: this.getDesignSystemOverrides(color), designSystemMergingFunction: this.props.designSystemMergingFunction }, (this.tag && (React.createElement(this.tag, Object.assign({}, this.unhandledProps(), { style: style }), this.props.children))) ||
                this.props.children));
        };
    }
    render() {
        return React.createElement(DesignSystemConsumer, null, this.withContext);
    }
    get tag() {
        return this.props.tag;
    }
}
Background.defaultProps = {
    tag: "div",
    value: neutralLayerL1,
    drawBackground: true,
};
export * from "./background.props";
